// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrap[data-v-070218a0]{display:flex;flex-direction:column;align-items:center;width:100%;margin-top:var(--spaces-l)}.base-modal-confirm__image[data-v-070218a0]{margin-bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
